<template>
  <div
    class="slide-content slide-title-content"
    :class="{
      'content-sm': hasClassContentSm,
      'content-xs': hasClassContentXs,
      'no-height': hasClassNoHeight,
    }"
  >
    <div
      class="title-slide"
      :class="{'white-text': isTextColourLight,
               'flex': slideActive.type !== 'ideas',
               'is-exporting-pdf': isScreenCapture}"
    >
      <span
        v-if="isCommonSlideTitleVisible"
        :class="slideTitleClass"
        class="title-slide-text"
      >
        <SlideTitleEditor
          :class="{
            'hidden': hasClassHiddenSlideTitleEditor,
            'opacity-0': isQuizRuleScreen,
          }"
          type="slide-title"
          :maxChars="slideActive.type === 'spinnerWheel' ? 50 : 300"
        />
        <!-- Show image sticker on heading title -->
        <div
          v-if="slideActive.image && slideActive.type === 'ideas'"
          class="ideas-show-image"
          @click.stop="$emit('hideQuestionImage')"
        >
          <aha-icon
            name="image"
            class="mr-1"
            :class="{'text-base-0': isTextColourLight,
                     'text-secondary-50': isTextColourDark}"
          />
          <span v-if="slideActive.showQuestionImage" class="pt-2">{{ $i18nPresenter.t('Hide image') }}</span>
          <span v-else class="pt-2">{{ $i18nPresenter.t('Show image') }}</span>
        </div>

      </span>
    </div>

    <div
      v-if="(!presentation.teamPlay || showSoloRanking) && slideActive.type === 'leaderboard'"
      class="count-player"
    >
      {{ $t('players', { msg: slideActive.audiencesCount || '…' }) }}
    </div>
    <div
      v-if="presentation.teamPlay && !showSoloRanking && slideActive.type === 'leaderboard'"
      class="ml-2 count-player"
    >
      <span v-if="slideActive.audiencesCount < 2">
        {{ slideActive.audiencesCount || '…' }} {{ $t('team') }}
      </span>
      <span v-if="slideActive.audiencesCount > 1">
        {{ slideActive.audiencesCount || '…' }} {{ $t('teams') }}
      </span>
    </div>

    <div
      v-if="slideTitleDescVisible && slideActive.titleDesc"
      class="title-desc-slide"
      :style="{ 'background-color': _setDescColor(),
                'color': slideActive.textColour }"
    >
      <p class="mb-0">
        <UIPreLine :text="slideActive.titleDesc" />
      </p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import utils from '@/util'
import QuizStatuses from '@/constant/QuizStatuses'
import UIPreLine from '@/components/UI/PreLine'
import SlideTitleEditor from '@/components-v2/presentation-editor/middle/SlideTitleEditor.vue'

export default {
  components: {
    UIPreLine,
    SlideTitleEditor,
  },
  props: {
    showSoloRanking: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      slideTitleClass: '',
      pollTitle: '',
      openEndedTitle: '',
      wordCloudTitle: '',
      imageSlideTitle: '',
      questionTitle: '',
      scaleSlideTitle: '',
      ideasSlideTitle: '',
      spinnerWheelTitle: '',
      QuizStatuses,
    }
  },
  computed: {
    ...mapGetters(['isPresenting', 'isBackstage', 'isTextColourLight']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      sharePresentation: (state) => state.sharePresentation,
      isPlayDemoMode: (state) => state.isPlayDemoMode,
      isScreenCapture: (state) => state.isScreenCapture,
    }),
    hasClassContentSm() {
      return this.presentation.hideInstructionBar && this.slideActive.type != 'document'
    },
    hasClassContentXs() {
      return this.presentation.logo && this.presentation.hideInstructionBar && this.slideActive.type != 'document'
    },
    hasClassNoHeight() {
      const slideTypes = ['qrcode', 'textSlide', 'youtube']
      return slideTypes.includes(this.slideActive.type)
    },
    hasClassInlineFlex() {
      const slideTypes = ['ideas', 'leaderboard']
      return slideTypes.includes(this.slideActive.type)
    },
    hasClassHiddenSlideTitleEditor() {
      const { type } = this.slideActive
      return type === 'pickAnswer' && !this.isQuizTitleVisible
    },
    isPollSlide() {
      const slideTypes = ['multipleChoice', 'imageChoice']
      return slideTypes.includes(this.slideActive.type)
    },
    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
    isTextColourDark() {
      return !this.isTextColourLight
    },
    slideTitleDescVisible() {
      return this.slideActive.type === 'spinnerWheel' || this.slideActive.type === 'scale' ||
            this.slideActive.type === 'imageChoice' || this.slideActive.type === 'multipleChoice' ||
            this.slideActive.type === 'openEnded' || this.slideActive.type === 'wordCloud' ||
            this.slideActive.type === 'question' || this.slideActive.type === 'ideas' ||
            (this.slideActive.type === 'pickAnswer' && this.slideActive.quizStatus !== QuizStatuses.RULE_SCREEN && this.slideActive.quizStatus !== QuizStatuses.LOBBY_SCREEN) ||
            (this.slideActive.type === 'pickAnswer' && !this.isPresenting) ||
            (this.slideActive.type === 'pickAnswer' && this.sharePresentation)
    },
    isQuizLobbyScreen() {
      return this.slideActive.quizStatus == QuizStatuses.LOBBY_SCREEN
    },
    isQuizRuleScreen() {
      if (this.sharePresentation || !this.isPresenting) return false
      return this.slideActive.quizStatus == QuizStatuses.RULE_SCREEN
    },
    isQuizTitleVisible() {
      return this.sharePresentation || !this.isPresentingOrBackstage
        || (this.isPresentingOrBackstage && !this.isQuizLobbyScreen)
    },
    isCommonSlideTitleVisible() {
      const slideTypes = ['textSlide', 'bulletPoints', 'qrcode', 'youtube', 'document', 'googleSlides']
      return !slideTypes.includes(this.slideActive.type)
    },
  },
  watch: {
    slideActive: function watchSlideActive() {
      this.setClassFontSize()
    },
  },
  mounted() {
    this.setClassFontSize()
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),

    setClassFontSize() {
      const { slideActive } = this.$store.state
      if (slideActive.title) {
        this.slideTitleClass = 'title-md-fontsize'
        if (
          slideActive.title.length >= 70 &&
          slideActive.title.length <= 110
        ) {
          this.slideTitleClass = 'title-sm-fontsize'
        } else if (slideActive.title.length > 110 && slideActive.title.length <= 160) {
          this.slideTitleClass = 'title-xs-fontsize'
        } else if (slideActive.title.length > 160 && slideActive.title.length <= 250) {
          this.slideTitleClass = 'title-2xs-fontsize'
        } else if (slideActive.title.length > 250) {
          this.slideTitleClass = 'title-3xs-fontsize'
        }
      } else {
        this.slideTitleClass = 'title-md-fontsize'
      }
    },

    _setDescColor() {
      if (!this.slideActive.titleDesc) return false

      // Change base color form HEX to RGBA
      // Background's alpha = 0.2
      const colorToRgba = utils.hexToRgba(this.slideActive.baseColour)

      if (!colorToRgba) return false

      return utils.changeRgbaColor(colorToRgba, '0.85')
    },
  },
}
</script>

<style lang="scss" scoped>
.slide-content {
  width: 98%;
  margin: 0 auto;
  position: relative;
  // backface-visibility: hidden;
  &:hover {
    .title-desc-slide {
      opacity: 1;
      visibility: visible;
      z-index: 500;
    }
  }

  &.no-height {
    height: 0;
    padding: 0 !important;
  }

  .title-desc-slide {
    opacity: 0;
    visibility: hidden;
    padding: 10px;
    transition: opacity 0.2s ease;
    -webkit-transition: opacity 0.2s ease;
    position: absolute;
    top: 100%;
    z-index: 0;
    border-radius: 8px;
    font-size: 105%;
    cursor: auto;
    left: 0;
    width: 60%;
    &:hover {
      opacity: 0;
      z-index: 0;
    }
  }

  .title-slide {
    font-weight: bold;
    .title-md-fontsize {
      font-size: 47px;
    }
    .title-sm-fontsize {
      font-size: 38px;
    }
    .title-xs-fontsize {
      font-size: 34px;
    }
    .title-2xs-fontsize {
      font-size: 28px;
    }
    .title-3xs-fontsize {
      font-size: 24px;
    }
    &.is-exporting-pdf .title-xs-fontsize {
      font-size: 28px;
    }
  }
}
.count-player {
  opacity: 0.4;
  font-weight: normal;
  font-size: 28px;
  @apply pb-1 pl-3;
}
.ideas-show-image {
  @apply text-sm cursor-pointer text-secondary-50 font-normal pl-3;
  color: inherit;
}
</style>
